<icc-list [searchable]="true" [items]="hinges"
          [itemTemplate]="'itemImgTitle'"
          itemImgHeight="medium"
          (select)="selectHinge($event)"
          [selected] = "selectedHingeId"></icc-list>
